import { Icon } from '@/components/icon';
import { company } from '@/data/company';

export function EmergencyBar(): React.ReactNode {
  return (
    <div className="bg-emergency text-paper" role="region" aria-label="Notfall-Hinweis">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-3 py-2 text-xs sm:justify-between sm:gap-2 sm:px-8 sm:text-sm">
        <div className="flex min-w-0 items-center gap-2">
          <Icon name="TriangleAlert" className="h-3.5 w-3.5 shrink-0 sm:h-4 sm:w-4" />
          <span className="truncate">
            <span className="hidden sm:inline">Sturmschaden? </span>Notfall? 24/7 erreichbar.
          </span>
        </div>
        <a
          href={company.phone.href}
          className="inline-flex shrink-0 items-center gap-1 font-semibold underline-offset-2 hover:underline"
        >
          <Icon name="Phone" className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
          {company.phone.display}
        </a>
      </div>
    </div>
  );
}
